import { CHAIN_ID } from "utils/network";
import { useNetwork } from "wagmi";

export default function useChainId(): number | undefined {
  const { chain } = useNetwork();
  return chain?.id || Number(CHAIN_ID);
}
